<template>
  <v-card width="180" class="cardMedia" color="lightGray">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <div class="text-subtitle-2 ma-2 title" v-bind="attrs" v-on="on">{{ cardTitle }}</div>
      </template>
      <span>{{ tip }}</span>
    </v-tooltip>

    <div class="text-subtitle-2 ma-2">{{ cardTime }}</div>
  </v-card>
</template>

<script>
export default {
  name: 'CardAverage',
  props: ['cardTitle', 'cardTime', 'tip'],
}
</script>

<style scoped>
.cardMedia {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.title {
  height: 2px;
}
</style>
